import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'start-tour-popup',
    templateUrl: './start-tour-popup.component.html',
    styleUrls: ['./start-tour-popup.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StartTourPopupComponent implements OnInit {
    @Input() tourUrl: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}
